import { useCallback, useEffect, useState } from "react";
import { PAGE_MATCHED } from "../utils/constant";

const usePage = (location) => {
  const [matched, setMatchLocation] = useState();
  const pageMatched = useCallback(
    (loc) => setMatchLocation(loc),
    [setMatchLocation]
  );

  useEffect(() => setMatchLocation(location), [location]);

  switch (matched) {
    case "details":
      return [PAGE_MATCHED.DETAILS_VIEW, pageMatched];
    case `add-new-condition`:
    case `add-new-course`:
    case `add-new-case`:
    case `add-new-node`:
    case `add-new-user`:
      return [PAGE_MATCHED.CREATE_NEW_VIEW, pageMatched];
    case `edit`:
      return [PAGE_MATCHED.EDIT_VIEW, pageMatched];
    //default match landing
    default:
      return [PAGE_MATCHED.LANDING_VIEW, pageMatched];
  }
};

export default usePage;
